import * as microsoftGraph from 'api/microsoftGraphAPI';

// Fonction pour récupérer l'ID du groupe de sécurité
export async function getIDSecurityGroup(groupName) {
    try {
        const response = await microsoftGraph.getIDSecurityGroup(groupName);
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération de l\'ID du groupe de sécurité :', error);
        throw new Error('Erreur lors de la récupération de l\'ID du groupe de sécurité.');
    }
}

// Fonction pour récupérer les utilisateurs du groupe de sécurité   
export async function getUsersByIDSecurityGroup(groupId) {
    try {
        const response = await microsoftGraph.getUsersByIDSecurityGroup(groupId);
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des utilisateurs du groupe de sécurité :', error);
        throw new Error('Erreur lors de la récupération des utilisateurs du groupe de sécurité.');
    }
}

